import React, { useState, useEffect } from 'react'

import Snackbar from '@mui/material/Snackbar'
import Button from '@mui/material/Button'

const SnackMessage = ({
  open = false,
  message = null,
  onClose,
  autoHideDuration = 30000,
  useScrollPosition = false,
  themeClass
}) => {
  const [snackbarPosition, setSnackbarPosition] = useState({ top: 0, left: 0 })
  console.log('DEBUG: SnackMessage', open, message)


  const handleUserInteraction = (event) => {
    const { clientX, clientY } = event
    setSnackbarPosition({ top: clientY + 80, left: clientX })
  }

  const handleScroll = () => {
    const scrollY = window.scrollY
    setSnackbarPosition((prev) => ({ ...prev, top: scrollY + 80 }))
  }

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      // Ignore clickaway events if needed
      return
    }
    if (onClose) {
      onClose(event, reason) // Call the parent callback
    }
  }

  useEffect(() => {
    // Add event listeners for clicks, taps, and scrolls
    window.addEventListener('click', handleUserInteraction)
    window.addEventListener('touchstart', handleUserInteraction)
    window.addEventListener('scroll', handleScroll)

    return () => {
      // Cleanup event listeners
      window.removeEventListener('click', handleUserInteraction)
      window.removeEventListener('touchstart', handleUserInteraction)
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  const isNearBottom = snackbarPosition.top > 1000

  const style = useScrollPosition && !isNearBottom
    ? {
      backgroundColor: themeClass?.color1 || `#000550`,
      bottom: 'unset !important',
      color: '#FFFFFF',
      height: 'auto',
      left: '50% !important',
      position: 'fixed',
      transform: 'translateX(-50%)',
      top: snackbarPosition.top,
    }
    : {
      backgroundColor: themeClass?.color1 || `#000550`,
      bottom: '100px !important',
      color: '#FFFFFF',
      height: 'auto',
    }

  return (
    <Snackbar
      autoHideDuration={autoHideDuration}
      open={open}
      message={message}
      onClose={handleClose}
      sx={style}
      action={
        <Button color="inherit" size="small" onClick={handleClose}>
          DISMISS
        </Button>
      }
    />
  )
}

export default SnackMessage